import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { TransactionMode, } from '@tencent/memoire-core';
import { IDBEngineTable } from './table';
import { IDBEngineTransaction } from './transaction';
var IDBEngineDatabase = /** @class */ (function () {
    function IDBEngineDatabase(idbDatabase, engineAspect) {
        this.idbDatabase = idbDatabase;
        this.engineAspect = engineAspect;
        this.name = idbDatabase.name;
        this.version = idbDatabase.version;
        this.tableNames = __spreadArray([], __read(idbDatabase.objectStoreNames));
        if (this.engineAspect) {
            this.applyAspectPatch();
        }
    }
    IDBEngineDatabase.prototype.setVersionChangeListener = function (listener) {
        this.idbDatabase.addEventListener('versionchange', function (event) {
            listener(event.oldVersion, event.newVersion);
        });
    };
    IDBEngineDatabase.prototype.close = function () {
        this.idbDatabase.close();
    };
    IDBEngineDatabase.prototype.createTable = function (tableName, options) {
        var object = this.idbDatabase.createObjectStore(tableName, options);
        return new IDBEngineTable(TransactionMode.VERSION_CHANGE, object);
    };
    IDBEngineDatabase.prototype.deleteTable = function (name) {
        this.idbDatabase.deleteObjectStore(name);
    };
    IDBEngineDatabase.prototype.transaction = function (tableNames, mode) {
        var transaction = this.idbDatabase.transaction(tableNames, mode);
        return new IDBEngineTransaction(transaction, this.engineAspect);
    };
    IDBEngineDatabase.prototype.table = function (tableName, mode) {
        return __awaiter(this, void 0, void 0, function () {
            var proxyTransaction, transaction, proxyObjectStore;
            return __generator(this, function (_a) {
                proxyTransaction = this.idbDatabase.transaction([tableName], mode);
                transaction = new IDBEngineTransaction(proxyTransaction);
                proxyObjectStore = proxyTransaction.objectStore(tableName);
                return [2 /*return*/, new IDBEngineTable(mode, proxyObjectStore, this.engineAspect, transaction)];
            });
        });
    };
    /**
     * bind the hook stub to the database object
     */
    IDBEngineDatabase.prototype.applyAspectPatch = function () {
        var _a;
        var databaseAspect = (_a = this.engineAspect) === null || _a === void 0 ? void 0 : _a.database;
        databaseAspect === null || databaseAspect === void 0 ? void 0 : databaseAspect.deleteTable.patch(this, 'deleteTable');
        databaseAspect === null || databaseAspect === void 0 ? void 0 : databaseAspect.createTable.patch(this, 'createTable');
        databaseAspect === null || databaseAspect === void 0 ? void 0 : databaseAspect.transaction.patch(this, 'transaction');
        databaseAspect === null || databaseAspect === void 0 ? void 0 : databaseAspect.table.patch(this, 'table');
        databaseAspect === null || databaseAspect === void 0 ? void 0 : databaseAspect.close.patch(this, 'close');
    };
    return IDBEngineDatabase;
}());
export { IDBEngineDatabase };
//# sourceMappingURL=database.js.map